import request from '../util/request'

const baseUrl = process.env.NODE_ENV === 'production' ? '' : '/vehicleMap'

export function getUserInfoApi(params) {
  return  request({
        url: baseUrl + "/lclock/home",
        methods: "get",
        params:params
      })
}

export function getMenuApi() {
  return  request({
    url: baseUrl + "/lcmenu",
    method: "get"
  })
}

export function lclockApi(params) {
  return  request({
        url: baseUrl + "/lclock",
        methods: "get",
        params:params
      })
}
 


// WEBPACK FOOTER //
// ./src/api/runinfo.js